<template>
  <div class="overall-container">
    <filter-items
      v-model="params"
      :languages-list="languagesList"
      :qa-methods-list="qaMethodsList"
      :qa-models-list="qaModelsList"
      :report-type-list="reportTypeList"
      :text-category-list="textCategoryList"
      :industry-field-list="industryFieldList"
      :creation-date="creationDate"
      @date-change="$emit('date-change', $event)"
      title="Reports KPIs"
    />
    <div class="graphics-relative-wrapper">
      <pre-loader :preloader-status="ajaxLoading" />
      <div class="reports-graphics-container">
        <charts-constructor
          :options="graphic_options"
        />
        <div class="stats-container">
          <stat-item :value="reports_all.reports" accent>reports</stat-item>
          <stat-item :value="reports_all.error_items" accent>error items</stat-item>
          <stat-item :value="reports_all.error_points" accent>error points</stat-item>
          <stat-item :value="reports_all.qa_level" accent color="#006dad">QA level</stat-item>
          <stat-item
            :value="reports_all.qa_score"
            accent
            :color="getStatScoreColor(reports_all.qa_score, reports_all.qa_level)">
            QA score
          </stat-item>

          <stat-item :value="reports_data.reports.failed" color="#ff0303">failed reports</stat-item>
          <stat-item :value="reports_data.error_items.failed" color="#ff0303">error items</stat-item>
          <stat-item :value="reports_data.error_points.failed" color="#ff0303">error points</stat-item>
          <stat-item :value="reports_data.qa_level.failed" color="#006dad">QA level</stat-item>
          <stat-item
            :value="reports_data.qa_score.failed"
            :color="getStatScoreColor(reports_data.qa_score.failed, reports_data.qa_level.failed)">
            QA score
          </stat-item>

          <stat-item :value="reports_data.reports.success" color="#1a9f06">succesfull reports</stat-item>
          <stat-item :value="reports_data.error_items.success" color="#1a9f06">error items</stat-item>
          <stat-item :value="reports_data.error_points.success" color="#1a9f06">error points</stat-item>
          <stat-item :value="reports_data.qa_level.success" color="#006dad">QA level</stat-item>
          <stat-item
            :value="reports_data.qa_score.success"
            :color="getStatScoreColor(reports_data.qa_score.success, reports_data.qa_level.success)">
            QA score
            </stat-item>

          <stat-item :value="reports_data.reports.passed" color="#fbb500">passed reports</stat-item>
          <stat-item :value="reports_data.error_items.passed" color="#fbb500">error items</stat-item>
          <stat-item :value="reports_data.error_points.passed" color="#fbb500">error points</stat-item>
          <stat-item :value="reports_data.qa_level.passed" color="#006dad">QA level</stat-item>
          <stat-item
            :value="reports_data.qa_score.passed"
            :color="getStatScoreColor(reports_data.qa_score.passed, reports_data.qa_level.passed)">
            QA score
          </stat-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import props from '../props.js';

export default Vue.extend({
  props: {
    ...props,
  },
  components: {
    'filter-items': () => import('../filters.vue'),
    'charts-constructor': () =>
        import('@/components/charts/chartConstructor/index.js'),
    'stat-item': () => import('../StatItem.vue'),
    'pre-loader': () => import('@/components/preloader/index.vue'),
  },
  watch: {
    creationDate() {
      this.getData();
    },
    value: {
      deep: true,
      handler() {
        this.getData();
      },
    },
  },
  data: () => ({
    ajaxLoading: false,
    reports_data: {
      reports: {
        failed: 0,
        success: 0,
        passed: 0,
      },
      error_items: {
        failed: 0,
        success: 0,
        passed: 0,
      },
      error_points: {
        failed: 0,
        success: 0,
        passed: 0,
      },
      qa_level: {
        failed: 0,
        success: 0,
        passed: 0,
      },
      qa_score: {
        failed: 0,
        success: 0,
        passed: 0,
      },
    },
  }),
  computed: {
    params: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    reports_all() {
      const output = Object();
      const repTypes = ['failed', 'success', 'passed'];
      ['reports', 'error_items', 'error_points'].forEach((key) => {
        output[key] = repTypes.reduce(
          (acc, type) => (acc += this.reports_data[key][type] || 0),
          0
        );
      });
      ['qa_level', 'qa_score'].forEach((key) => {
        output[key] = Math.floor(
          repTypes.reduce(
            (acc, type) =>
              (acc +=
                  this.reports_data[key][type] * this.reports_data.reports[type]),
            0
          ) / output.reports || 1
        );
      });
      return output;
    },
    graphic_options() {
      return {
        chart: {
          type: 'bar',
        },
        title: null,
        xAxis: {
          categories: [
            ...Object.keys(this.reports_data.reports).map((name) => {
              return name === 'failed' ? 'Failed reports' : (
                name === 'success' ? 'Succesfull reports' : 'Passed reports'
              );
            }),
          ],
        },
        yAxis: {
          title: null,
        },
        legend: {
          enabled: false,
        },
        series: [{
          name: 'Count',
          data: [...Object.keys(this.reports_data.reports).map((key, ind) => ({
            x: ind,
            y: this.reports_data.reports[key],
            color: key === 'failed' ? '#ff0303' : (
              key === 'success' ? '#1a9f06' : '#fbb500'),
          }))],
        }],
      };
    },
  },
  methods: {
    getData() {
      this.ajaxLoading = true;
      new Promise((res) => {
        setTimeout(res, 1000);
      })
        .then(() => {
          this.reports_data = {
            reports: {
              failed: 9,
              success: 18,
              passed: 3,
            },
            error_items: {
              failed: 40,
              success: 3,
              passed: 15,
            },
            error_points: {
              failed: 2285,
              success: 178,
              passed: 207,
            },
            qa_level: {
              failed: 55,
              success: 70,
              passed: 68,
            },
            qa_score: {
              failed: 40,
              success: 76,
              passed: 68,
            },
          };
        })
        .finally(() => {
          this.ajaxLoading = false;
        });
    },
    getStatScoreColor(score, level) {
      return level === score ? '#fbb500' : (score > level ? '#1a9f06' : '#ff0303');
    },
  },
  mounted() {
    this.getData();
  },
});
</script>

<style lang="scss">
  .overall-container {
    .graphics-relative-wrapper {
      position: relative;
    }
    .reports-graphics-container {
      background: #fff;
      padding-top: 20px;

      .stats-container {
        display: grid;
        grid-gap: 10px 5px;
        grid-template-columns: repeat(5, 1fr);
      }
    }
  }
</style>
